<div
  class="rs-flex-columns small-12 medium-6"
  data-masonry-item
  (click)="openCard($event)"
  [ngSwitch]="cardType"
  [ngStyle]="{
    cursor: product?.productReadOnly ? 'not-allowed' : 'auto'
  }"
  data-tms-event="card-click-impression"
  attr.data-tms-card-zone="{{
    product.packDescription ? product.packDescription : outOfPackCardZoneTagging
  }}"
  attr.data-tms-card-name="{{ product.productDescription }}"
  attr.data-tms-product="{{ jsonProduct }}"
  attr.data-tms-button-name="{{ product.productDescription }}"
  [attr.data-cy]="'usageOverview' + productType"
>
  <div
    class="panel rs-panel-clickable"
    [ngStyle]="{
      'pointer-events': product?.productReadOnly ? 'none' : 'auto'
    }"
    [attr.data-cy]="product.plc + 'ProductCard'"
  >
    <a href="javaScript:void(0)" class="rs-link-no-decoration rs-txt-c1">
      <div class="rs-flex-row rs-flex-middle rs-flex-collapse">
        <div class="rs-flex-column rs-flex-shrink">
          <h3
            class="rs-tit6 rs-txt-c1"
            [ngClass]="!product.isCoreProduct ? 'rs-padding-bottom2' : ''"
          >
            {{
              !isMyMobile
                ? product.productDescription
                : ("products.overview.myMobile" | translate)
            }}
          </h3>
        </div>
        <mprd-exceeding-amount
          [product]="product"
          *ngIf="isExceedingAmountShown"
        ></mprd-exceeding-amount>
      </div>
      <p
        x-ms-format-detection="none"
        *ngIf="product.accessNumber && product.isCoreProduct"
      >
        <span *ngIf="isMyMobile" [attr.data-cy]="'px-mobile-description'"
          >{{ product.productDescription }} |
        </span>
        <mprd-access-number-formatter
          [accessNumber]="product.accessNumber"
          [plc]="product.plc"
          [internetDescription]="internetDescription"
          *ngIf="product.plc !== PlcCodes.EP && product.plc !== PlcCodes.LDM"
        ></mprd-access-number-formatter>
      </p>
      <mprd-message-box
        *ngIf="!isExceedingAmountShown"
        [messageBox]="{
          type: 'warning',
          title: 'Some of the costs not shown',
          description:
            'Some costs may not appear (e.g. roaming, mobile payments)'
        }"
        taggingName="product.overview"
        data-cy="copperStopSelling"
      ></mprd-message-box>
    </a>
    <a
      href="javaScript:void(0)"
      class="rs-link-no-decoration rs-txt-c1"
      *ngIf="['MOBILE', 'INTERNET'].includes(productType)"
    >
      <px-usage-overview-container
        [product]="usageProduct"
        (isInitialized)="usageInitialized($event)"
        [attr.data-cy]="'usageOverviewComponent'"
        [clickAddDataButtonCallback]="clickAddDataButtonCallback"
      ></px-usage-overview-container>
    </a>

    <a href="javaScript:void(0)" class="rs-link-no-decoration rs-txt-c1">
      <div
        class="rs-panel-collapse clearfix rs-bg-grey1 rs-no-margin-top rs-no-margin-bottom"
        *ngIf="
          (product?.options?.length > 0 &&
            [PlcCodes.TV, PlcCodes.FT, PlcCodes.EP].includes(product.plc)) ||
          PlcCodes.DNS == product.plc
        "
      >
        <div
          *ngIf="
            product?.options?.length > 0 &&
            [PlcCodes.TV, PlcCodes.FT].includes(product.plc)
          "
        >
          <h4 class="rs-tit6">
            {{ "products.overview.card.active.options" | translate }}
          </h4>
          <p class="rs-txt-purple">
            <ng-container *ngFor="let option of product.options; last as last">
              <span
                *ngIf="
                  option.optionCodeForDescription !== disneyPlusPremiumCode &&
                  isFeatureFlag
                "
              >
                {{ option.name }}<br *ngIf="!last" />
              </span>
              <span *ngIf="!isFeatureFlag">
                {{ option.name }}<br *ngIf="!last" />
              </span>
            </ng-container>
          </p>
        </div>
        <div *ngIf="PlcCodes.EP == product.plc">
          <p>
            <strong
              *ngFor="let option of product.options"
              class="rs-txt-purple"
              >{{ option.name }}</strong
            >
          </p>
        </div>
        <div *ngIf="product && product.plc === PlcCodes.DNS">
          <p
            class="rs-txt-purple rs-font-pxB"
            *ngIf="!product.pendingOrder && product.free === undefined"
          >
            {{ product.productShortDescription }}
          </p>
          <a
            *ngIf="
              product.free !== undefined &&
              product.free &&
              !product.pendingOrder
            "
            href="javascript:void(0)"
            class="rs-btn rs-btn-third"
            >{{ product.productShortDescription
            }}<i
              class="rs-icon-btn-third rs-margin-left1"
              aria-hidden="true"
            ></i
          ></a>
          <p *ngIf="product.pendingOrder" class="rs-txt-warning rs-font-pxB">
            <i class="icon-Stopwatch rs-margin-right1" aria-hidden="true"></i
            >{{ "products.overview.card.activationIsPending" | translate }}
          </p>
        </div>
      </div>
      <div
        *ngIf="product && product.plc === PlcCodes.LDM"
        class="rs-panel-collapse rs-bg-grey1 clearfix"
        data-cy="ldmCard"
        data-tms-event="card-click-impression"
        data-tms-card-zone="other products"
        data-tms-card-name="{{ product.productDescription }}"
        data-tms-product="{{ jsonProduct }}"
      >
        <p
          class="rs-txt-purple rs-font-pxB"
          *ngIf="extractLDMDomainName()"
          data-cy="ldmDomainName"
        >
          {{ extractLDMDomainName() }}
        </p>
        <div class="rs-entrypoint-container">
          <a
            href="javascript:void(0)"
            (click)="handleLDMLinks('manage')"
            class="rs-entrypoint"
            data-cy="ldmManageWebsite"
            data-tms-button-name="{{
              'products.overview.ldm.manageYourWebsite.label' | translate
            }}"
          >
            <span class="rs-entrypoint-title">{{
              "products.overview.ldm.manageYourWebsite.label" | translate
            }}</span>
            <span class="rs-entrypoint-arrow" aria-hidden="true"></span>
          </a>
          <a
            href="javascript:void(0)"
            (click)="handleLDMLinks('addProducts')"
            class="rs-entrypoint"
            data-cy="ldmAddProducts"
            data-tms-button-name="{{
              'products.overview.ldm.addProducts.label' | translate
            }}"
          >
            <span class="rs-entrypoint-title">{{
              "products.overview.ldm.addProducts.label" | translate
            }}</span>
            <span class="rs-entrypoint-arrow" aria-hidden="true"></span>
          </a>
          <a
            href="javascript:void(0)"
            (click)="handleLDMLinks('changeSubscription')"
            class="rs-entrypoint"
            data-cy="ldmChangeSubscription"
            data-tms-button-name="{{
              'products.overview.ldm.changeSubscription.label' | translate
            }}"
          >
            <span class="rs-entrypoint-title">{{
              "products.overview.ldm.changeSubscription.label" | translate
            }}</span>
            <span class="rs-entrypoint-arrow" aria-hidden="true"></span>
          </a>
        </div>
      </div>
      <ng-container
        *ngIf="
          [PlcCodes.MV].includes(product.plc) &&
          isProductOfferEligibleForPenalty
        "
      >
        <div
          class="rs-panel-collapse clearfix rs-bg-grey1 rs-no-margin-top rs-no-margin-bottom"
        >
          <a
            href="javascript:void(0)"
            class="rs-btn rs-btn-third"
            (click)="navigateToMyJointOffer()"
          >
            {{ "products.card.jointOffer.link.label" | translate }}
            <i class="rs-icon-btn-third rs-margin-left1" aria-hidden="true"></i>
          </a>
          <mprd-jo-renewal-card
            [product]="product"
            [outOfPackCardZoneTagging]="outOfPackCardZoneTagging"
          ></mprd-jo-renewal-card>
        </div>
      </ng-container>
    </a>

    <div *ngIf="hasGoToOptionsItem" class="rs-panel-collapse rs-bg-grey2">
      <a
        href="javascript:void(0)"
        class="rs-btn rs-btn-third"
        (click)="redirectToOptionsSection($event)"
        >{{ "products.overview.card.goto.options" | translate }}
        <i class="rs-icon-btn-third rs-margin-left1" aria-hidden="true"></i
      ></a>
    </div>
  </div>
  <div *ngIf="hasEasyProtect">
    <mprd-always-protected></mprd-always-protected>
  </div>
</div>
